package ru.villawonka.app.presentation.model

import org.jetbrains.compose.resources.DrawableResource
import ru.villawonka.app.domain.model.CountryDomain
import ru.villawonka.app.presentation.screens.variantPicker.model.VariantPickerItemUIModel
import ru.villawonka.app.resources.AppResources
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.ic_indonesia
import villawonka.composeapp.generated.resources.ic_thailand
import villawonka.composeapp.generated.resources.ic_vietnam

sealed class CountryUIModel {

    abstract val icon: DrawableResource

    abstract val string: String

    class Indonesia : CountryUIModel() {

        override val icon: DrawableResource = Res.drawable.ic_indonesia

        override val string: String
            get() = AppResources.strings.countryIndonesia
    }

    class Thailand : CountryUIModel() {

        override val icon: DrawableResource = Res.drawable.ic_thailand

        override val string: String
            get() = AppResources.strings.countryThailand
    }

    class Vietnam : CountryUIModel() {

        override val icon: DrawableResource = Res.drawable.ic_vietnam

        override val string: String
            get() = AppResources.strings.countryVietnam
    }
}

fun CountryDomain.toUIModel(): CountryUIModel = when (this) {
    CountryDomain.INDONESIA -> CountryUIModel.Indonesia()
    CountryDomain.THAILAND -> CountryUIModel.Thailand()
    CountryDomain.VIETNAM -> CountryUIModel.Vietnam()
}

fun CountryUIModel.toDomainModel(): CountryDomain = when (this) {
    is CountryUIModel.Indonesia -> CountryDomain.INDONESIA
    is CountryUIModel.Thailand -> CountryDomain.THAILAND
    is CountryUIModel.Vietnam -> CountryDomain.VIETNAM
}

fun CountryUIModel.toVariantPickerItemUIModel() = VariantPickerItemUIModel(
    title = string,
)

fun VariantPickerItemUIModel.toCountryUIModel(): CountryUIModel? = when (title) {
    AppResources.strings.countryIndonesia -> CountryUIModel.Indonesia()
    AppResources.strings.countryThailand -> CountryUIModel.Thailand()
    AppResources.strings.countryVietnam -> CountryUIModel.Vietnam()
    else -> null
}